import { ONE_PAGE_STORE_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

export const onTrackGiftCheckoutPopupShow = async () => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: ONE_PAGE_STORE_TRACKER_TYPE.GiftCheckoutPopupShow,
    data: {
      event_category: 'Checkout',
    },
  });
};
